module.exports = __webpack_public_path__ + "site/img/18.28c0a247.jpg";